/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef } from "react";
import {
  EmptyState,
  PageHead,
  Banner,
  DashboardTopPortal,
  Button,
  AddAssetDropdown,
} from "shared";
import { SVG_ENUM, PACKET_ENUM, AssetCategorySlug } from "enums";
import { isDesktop } from "utils";
import "./InvestmentsPage.scss";
import InvestmentsTopBar from "./components/InvestmentsTopBar";
import InvestmentsTabs from "./components/InvestmentsTabs";
import AddInvestmentModal from "./components/AddInvestmentModal/AddInvestmentModal";
import AssetTilesList from "./components/AssetTilesList/AssetTilesList";
import { useInvestmentsState } from "./hooks/useInvestmentsState";
import { useGetInvestmentsGrouped } from "hooks/investments";
import { GroupedInvestmentsData } from "./types";
import {
  AddCompanyModal,
  AddCompanyClientModal,
  SellSharesModal,
} from "features/companies";
import TransactionsSideModal from "features/companies/TransactionsSideModal/TransactionsSideModal";
import { AddSharesModal } from "features/shares";
import { PacketModal } from "features/users";
import InvestmentsSummary from "./components/InvestmentsSummary/InvestmentsSummary";
import { openMeetingBooking } from "./utils";

const InvestmentsPage = () => {
  const transactionCompanyRef = useRef<any>(null);
  const [transactionCompany, setTransactionCompany] = useState<any>(null);
  const [sellSharesCompany, setSellSharesCompany] = useState<any>(null);
  const [addSharesCompany, setAddSharesCompany] = useState<any>(null);
  const [pendingOpenUuid, setPendingOpenUuid] = useState<string | null>(null);

  const openTransactionSideModal = (company: any) => {
    transactionCompanyRef.current = company;
    setTransactionCompany(company);
  };

  const returnToTransactionSideModal = (data?: any) => {
    console.log(data, "daaata");
    if (data?.availableShares !== undefined) {
      transactionCompanyRef.current = {
        ...transactionCompanyRef.current,
        sharesCount: data.availableShares,
      };
    }
    setSellSharesCompany(null);
    setAddSharesCompany(null);
    setTimeout(
      () => setTransactionCompany({ ...transactionCompanyRef.current }),
      100,
    );
  };

  const {
    tab,
    isAdmin,
    isCompanyInfoOpenModal,
    authorizedUser,
    modalManage,
    setModalManage,
    selectedSlug,
    setAddAsset,
    closeAddAssetModal,
    handleChangeTab,
    // page,
  } = useInvestmentsState();

  const { data: groupedInvestments, isLoading: isGroupedLoading } =
    useGetInvestmentsGrouped();

  const { data: archivedInvestments, isLoading: isArchivedLoading } =
    useGetInvestmentsGrouped(true);

  const typedGroupedData = groupedInvestments as
    | GroupedInvestmentsData
    | undefined;

  const typedArchivedData = archivedInvestments as
    | GroupedInvestmentsData
    | undefined;

  return (
    <>
      <PageHead
        title="Spółki w portfelu – podgląd inwestycji | App Reliance Pro"
        description="Zobacz wszystkie spółki w swoim portfelu inwestycyjnym. Aktualne dane, historia i wygodny dostęp w jednym miejscu."
      />

      <div className="companies">
        <InvestmentsTopBar
          tab={tab}
          isAdmin={isAdmin}
          isCompanyInfoOpenModal={isCompanyInfoOpenModal}
          onAssetSelect={setAddAsset}
        />
        <div className="dashboard-content__wrapper">
          <div className="dashboard-content">
            <InvestmentsTabs
              tab={tab}
              userRole={authorizedUser?.role}
              handleChangeTab={handleChangeTab}
              hasArchivedData={
                !isArchivedLoading &&
                !!(typedArchivedData &&
                  (Object.keys(typedArchivedData.own ?? {}).length > 0 ||
                    Object.keys(typedArchivedData.reliance ?? {}).length > 0))
              }
            />
            {!isGroupedLoading && typedGroupedData && tab === "my" && (
              <>
                {isDesktop() ? (
                  <DashboardTopPortal>
                    <InvestmentsSummary />
                  </DashboardTopPortal>
                ) : (
                  <InvestmentsSummary />
                )}
                {!isDesktop() &&
                  (tab === "my" || (isAdmin && tab === "reliance")) && (
                    <div className="investmentsPage__mobile-actions">
                      <Button
                        onClick={openMeetingBooking}
                        className="button--strokeBlack investment-button"
                        label="Umów spotkanie"
                        svg={SVG_ENUM.CALENDAR}
                      />
                      <AddAssetDropdown
                        onSelect={(slug: AssetCategorySlug) =>
                          setAddAsset(slug)
                        }
                      />
                    </div>
                  )}
                {Object.keys(typedGroupedData.own ?? {}).length === 0 &&
                Object.keys(typedGroupedData.reliance ?? {}).length === 0 ? (
                  <EmptyState
                    className="companies-table__empty"
                    svg={SVG_ENUM.INFO}
                    text={
                      <p>
                        W tym miejscu pojawi się lista Twoich zakupionych
                        aktywów. Aby dodać aktywo zakupione poza Reliance,
                        kliknij przycisk <b>&quot;Dodaj aktywo&quot;</b> w
                        prawym górnym rogu.
                      </p>
                    }
                  />
                ) : (
                  <>
                    {!isAdmin && !authorizedUser?.package && (
                      <Banner
                        text={
                          <p>
                            Aby uzyskać dostęp do informacji rynkowych
                            i&nbsp;powiadomień{" "}
                            <b>konieczne jest zakupienie pakietu</b>
                          </p>
                        }
                        buttonLabel="Sprawdź dostępne pakiety"
                        buttonOnClick={() =>
                          setModalManage({ type: "packet", company: null })
                        }
                        className="companies__top-banner"
                      />
                    )}
                    {typedGroupedData.reliance &&
                      Object.keys(typedGroupedData.reliance).length > 0 && (
                        <AssetTilesList
                          categories={typedGroupedData.reliance}
                          title="Aktywa zakupione w Reliance"
                          otherSectionCategories={typedGroupedData.own}
                          pendingOpenUuid={pendingOpenUuid}
                          onPendingOpenComplete={() => setPendingOpenUuid(null)}
                        />
                      )}
                    {typedGroupedData.own &&
                      Object.keys(typedGroupedData.own).length > 0 && (
                        <>
                          <AssetTilesList
                            categories={typedGroupedData.own}
                            title="Aktywa zakupione poza Reliance"
                            banner={
                              !isAdmin &&
                              (authorizedUser?.package === PACKET_ENUM.BASIC ||
                                authorizedUser?.package ===
                                  PACKET_ENUM.STANDARD) ? (
                                <Banner
                                  text={
                                    <p>
                                      <b>Zakup wyższy pakiet</b>, aby odblokować
                                      dostęp do informacji rynkowych na temat
                                      aktywów zakupionych poza Reliance.
                                    </p>
                                  }
                                  buttonLabel="Zmiana pakietu"
                                  buttonOnClick={() =>
                                    setModalManage({
                                      type: "packet",
                                      company: null,
                                    })
                                  }
                                />
                              ) : undefined
                            }
                            isOwn={true}
                            otherSectionCategories={typedGroupedData.reliance}
                            pendingOpenUuid={pendingOpenUuid}
                            onPendingOpenComplete={() =>
                              setPendingOpenUuid(null)
                            }
                          />
                        </>
                      )}
                  </>
                )}
              </>
            )}
            {!isGroupedLoading &&
              typedGroupedData &&
              tab === "reliance" &&
              isAdmin && (
                <>
                  {typedGroupedData.reliance &&
                    Object.keys(typedGroupedData.reliance).length > 0 && (
                      <AssetTilesList categories={typedGroupedData.reliance} />
                    )}
                </>
              )}
            {tab === "other" && (
              <div className="investments-placeholder">
                <p>Tu pojawią się inne aktywa</p>
              </div>
            )}
            {tab === "archive" && (
              <>
                {!isArchivedLoading && typedArchivedData && (
                  <>
                    {Object.keys(typedArchivedData.own ?? {}).length === 0 &&
                    Object.keys(typedArchivedData.reliance ?? {}).length ===
                      0 ? (
                      <EmptyState
                        className="companies-table__empty"
                        svg={SVG_ENUM.INFO}
                        text={<p>Brak zarchiwizowanych aktywów.</p>}
                      />
                    ) : (
                      <>
                        {typedArchivedData.reliance &&
                          Object.keys(typedArchivedData.reliance).length >
                            0 && (
                            <AssetTilesList
                              categories={typedArchivedData.reliance}
                              title="Aktywa zakupione w Reliance"
                              isArchived={true}
                              otherSectionCategories={typedArchivedData.own}
                            />
                          )}
                        {typedArchivedData.own &&
                          Object.keys(typedArchivedData.own).length > 0 && (
                            <AssetTilesList
                              categories={typedArchivedData.own}
                              title="Aktywa zakupione poza Reliance"
                              isOwn={true}
                              isArchived={true}
                              otherSectionCategories={
                                typedArchivedData.reliance
                              }
                            />
                          )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <AddInvestmentModal
        isOpen={
          modalManage.type === "addAsset" &&
          selectedSlug !== "stocks" &&
          selectedSlug !== "shares"
        }
        onClose={closeAddAssetModal}
        selectedSlug={selectedSlug}
        isAdmin={isAdmin}
        mode="add"
        onSuccess={(data) => {
          if (data?.uuid) setPendingOpenUuid(data.uuid);
        }}
      />

      <AddCompanyModal
        isOpen={
          isAdmin &&
          modalManage.type === "addAsset" &&
          (selectedSlug === "stocks" || selectedSlug === "shares")
        }
        onClose={closeAddAssetModal}
        defaultType={
          selectedSlug === "stocks"
            ? "stock"
            : selectedSlug === "shares"
            ? "share"
            : undefined
        }
      />

      <AddCompanyClientModal
        isOpen={
          !isAdmin &&
          modalManage.type === "addAsset" &&
          (selectedSlug === "stocks" || selectedSlug === "shares")
        }
        onClose={closeAddAssetModal}
        defaultType={
          selectedSlug === "stocks"
            ? "stock"
            : selectedSlug === "shares"
            ? "share"
            : undefined
        }
        onSuccess={(data) => {
          const created = data?.["Created Company"];
          if (created?.company && created?.share) {
            console.log("czy to to mozliwe?");
            openTransactionSideModal({
              ...created.company,
              shareId: created.share.id,
              sharesCount: created.share.sharesCount,
              sharesValue: created.share.sharesValue,
              currencyUuid: created.share.currencyUuid,
              pricePerShare:
                created.share.sharesCount && created.share.sharesValue
                  ? created.share.sharesValue / created.share.sharesCount
                  : 0,
            });
          }
        }}
      />

      <TransactionsSideModal
        isOpen={!!transactionCompany}
        onClose={() => setTransactionCompany(null)}
        company={transactionCompany}
        setEditTransaction={(company) => {
          setTransactionCompany(null);
          setTimeout(() => setAddSharesCompany(company), 100);
        }}
        onAddTransactionClick={() => {
          setTransactionCompany(null);
          setTimeout(
            () => setSellSharesCompany(transactionCompanyRef.current),
            100,
          );
        }}
      />

      <SellSharesModal
        isOpen={!!sellSharesCompany}
        onSuccess={returnToTransactionSideModal}
        onClose={returnToTransactionSideModal}
        hardClose={() => setSellSharesCompany(null)}
        company={sellSharesCompany}
      />

      <AddSharesModal
        isOpen={!!addSharesCompany}
        onSuccess={returnToTransactionSideModal}
        onClose={returnToTransactionSideModal}
        hardClose={() => setAddSharesCompany(null)}
        company={addSharesCompany}
      />

      <PacketModal
        isOpen={modalManage.type === "packet"}
        onClose={() => setModalManage({ type: "", company: null })}
        parent="payment"
      />
    </>
  );
};

export default InvestmentsPage;
